<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" lg="10" offset-lg="1">
        <router-link :to="{ name: 'adminContacts' }"> ← 一覧に戻る </router-link>
        <h2 class="title mb-3">お問い合わせ設定</h2>
        <permission-guard situation="contact_management">
          <v-alert dense outlined type="error" style="width: 400px">
            <span class="caption">
              お問い合わせURLを入力すると、お問い合わせのリンクが入力されたURLになります
            </span>
          </v-alert>
          <v-form>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="site.contactUrl"
                  class="mb-2"
                  label="お問い合わせURL"
                  style="width: 350px"
                  required
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-text-field
                  v-model="site.contactEmail"
                  class="mb-2"
                  label="通知先メールアドレス"
                  style="width: 350px"
                  required
                />
              </v-col>
            </v-row>
          </v-form>
          <v-btn color="green darken-1" tile dark depressed @click="updateSite">
            更新
          </v-btn>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { deserialize } from 'deserialize-json-api'
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
export default {
  components: {
    PermissionGuard
  },
  data: () => {
    return {
      site: {}
    }
  },
  mounted: function () {
    axios.get('/api/site_reference').then(
      ({ data }) => {
        this.site = deserialize(data, {
          transformKeys: 'camelCase'
        }).data
      },
      (error) => {
        const payload = {
          status: error.response.status,
          message: `サイト情報の取得に失敗しました（${error.response.data.errors.toString()}）`
        }
        this.$store.dispatch('SystemMessageStore/createMessage', payload)
      }
    )
  },
  methods: {
    updateSite () {
      const query = {
        site: {
          contactUrl: this.site.contactUrl,
          contactEmail: this.site.contactEmail
        }
      }
      axios.patch(`/api/sites/${this.site.id}`, query).then(
        () => {
          const payload = {
            status: 200,
            message: '変更を保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors.toString()
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>
